import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const GuestRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem('auth');

  useEffect(() => {
    const timer = setTimeout(() => {
      const link = document.createElement('link');
      link.href = './assets/plugins/global/plugins.bundle.css';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }, 100);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return isAuthenticated ? <Navigate to="/" /> : children;
};

export default GuestRoute;
